import { track } from "@amplitude/analytics-react-native";
import toast from "src/swsh-native/toast";
import { useCallback, useState } from "react";
import { amp } from "src/api/amplitude";
import haptic from "src/helpers/haptic";
import log from "src/helpers/log";
import { enumNever } from "src/shared/helpers/generalHelpers";
import { useShareContext } from "../../contexts/ShareContext";
import getUniqueTypes from "../../helpers/getUniqueTypes";
import { nativeShareImage, nativeShareString } from "../../helpers/nativeShare";
import { ShareInstagramDMDataType } from "./shareInstagramDMHelpers";

const useShareInstagramDM = (data: ShareInstagramDMDataType) => {
	const { prefetched, onComplete, onSuccess } = useShareContext();
	const [loading, setLoading] = useState(false);
	const handlePress = useCallback(async () => {
		try {
			setLoading(true);
			track(amp.share.instagramDM, {
				types: getUniqueTypes(data),
				dataLength: data.length,
			});
			const item = data[0];
			if (!item) return;
			haptic("Light");
			const { didShare } = await (async () => {
				const type = item.type;
				switch (type) {
					case "Text":
					case "Url":
						const body = type === "Text" ? item.text : item.url;
						return await nativeShareString(body, {
							social: "Instagram",
						});
					case "LivePhoto":
					case "Image":
						const prefetchedData = prefetched.current[item.url];
						if (!prefetchedData) {
							throw new Error("Invalid prefetched data");
						}

						return await nativeShareImage([prefetchedData], {
							social: "Instagram",
						});
					default:
						return enumNever(type);
				}
			})();
			if (didShare) {
				onSuccess?.();
				if (item.successAmplitude) {
					track(item.successAmplitude.eventName, {
						...item.successAmplitude.eventProperties,
						shareType: item.type,
						shareAction: "InstagramDM",
					});
				}
			}
		} catch (err) {
			log.error({ err }, "Error in ShareInstagramStory");
			toast({
				preset: "error",
				title: "Something went wrong",
			});
		} finally {
			setLoading(false);
			onComplete?.();
		}
	}, [data, onComplete, onSuccess, prefetched]);

	return {
		loading,
		handlePress,
	};
};
export default useShareInstagramDM;
